
//mumbai with ifps on https://nft.storage/
const CONTRACT_ADDRESS =  '0x1250f8a91De448B480B40De8e28b08b47b61b723';

//rinkeby with ifps on https://nft.storage/
//const CONTRACT_ADDRESS =  '0x4258c56715ef43396079089bEE61753962e710cE';
//very first
//'0xA0762e3B7AA6Ad6d1ac4eeaA5b9A4836C1f86958';

const transformCharacterData = (characterData) => {
  return {
    name: characterData.name,
    imageURI: characterData.imageURI,
    hp: characterData.hp.toNumber(),
    maxHp: characterData.maxHp.toNumber(),
    attackDamage: characterData.attackDamage.toNumber(),
  };
};

export { CONTRACT_ADDRESS, transformCharacterData };